function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOWolontariat = function SvgOWolontariat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Warstwa 1",
    viewBox: "0 0 155.5 155.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24.57 101.28c0-30.04 22.38-52.04 53.18-52.04s53.18 22 53.18 52.04-23.72 52.04-53.18 52.04-53.18-21.81-53.18-52.04m53.18 30.23c16.26 0 28.89-11.67 28.89-30.23S94.01 71.05 77.75 71.05s-28.89 12.43-28.89 30.23 12.63 30.23 28.89 30.23",
    style: {
      fill: "#5ea570"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgOWolontariat;